const getModalId = () => ++counter;
export default getModalId;

let counter = 0;
